import type { Fetcher } from 'swr';

import axiosWithAuth from '@/lib/axios';

import { Postal, postalListSchema } from './types';

export const postalFetcher: Fetcher<Postal[]> = async (url: string) => {
  try {
    const { data } = await axiosWithAuth.get(url);
    const result = postalListSchema.safeParse(data.postalRecords);
    if (result.success) {
      return result.data;
    } else {
      throw new Error(result.error.message);
    }
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    }
    throw new Error('Unknown error');
  }
};
